export const openingHours = [9,19];
export const openingDates = ["04-01","11-01"];
export const intervalHoraires = 0.5;
